<div class="ui-search-input">
  <mat-icon class="ui-search-input__icon">search</mat-icon>
  <input
    class="ui-search-input__field"
    type="text"
    [placeholder]="placeholder"
    [value]="value"
    (input)="onInput($event)"
    (keyup.enter)="onEnter()" />
</div>
